import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Account} from "../model/account.model";
import {utf8Decode} from "sdv-common";
import {retryAfterMillis} from "../shared/constants";

@Injectable({providedIn: 'root'})
export class AccountService {

  private accounts: Account[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('accounts')
      .subscribe(response => {
        let accounts: Account[] = [];
        for (const account of response) {
          accounts.push(this.covertAccount(account));
        }
        this.accounts = accounts;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  private covertAccount(account) {
    return {
      id: utf8Decode(account.id),
      name: utf8Decode(account.name),
      icon: account.name.toLowerCase()
    };
  }

  getAccounts() {
    return this.accounts;
  }

  add($e, account) {
    this.apiService.post("accounts", {
      address: account.address,
      name: account.name
    }).subscribe(folder => {
      this.accounts.push(this.covertAccount(folder));
      $e.target.parentNode.querySelector('[data-bs-dismiss]')
        .dispatchEvent(new Event('click'));
    }, err => {
      this.apiService.error(account, err);
    });
  }
}
